import React from 'react';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import { ThemeProvider } from '@material-ui/styles';

import { Auth0ProviderWithHistory } from 'src/components/auth0/Auth0ProviderWithHistory';
import themes from 'src/themes';
import { AppRoutes } from 'src/AppRoutes';


const App = () => (
  <ThemeProvider theme={themes['nviro']}>
    <MuiPickersUtilsProvider utils={MomentUtils} >
      <Auth0ProviderWithHistory>
        <AppRoutes />
      </Auth0ProviderWithHistory>
    </MuiPickersUtilsProvider>
  </ThemeProvider>
);


export default App;
